// Receives a string and replaces the last 3 characters with an elipsis if it exceeds the maximum count
// If the elipsis is applied, the title of the element is set to the original text, so when the user hovers
// over the element, the full text will be shown
//
// Example:
// <span [elipsis]="20">Lorem ispum dolor sit amet</span>
//

import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({ selector: '[elipsis]' })
export class ElipsisDirective implements AfterViewInit {
  @Input('elipsis') max: number;

  constructor(private el: ElementRef) { }

  ngAfterViewInit(): void {
    if (!isNaN(this.max)) {
      this.apply();
    }
  }

  public apply(): void {
    const el = this.el.nativeElement;
    const value = el.innerText || el.textContent;

    if (value.length > this.max) {
      this.el.nativeElement.innerText = `${value.substring(0, this.max - 3)}...`;
      this.el.nativeElement.setAttribute('title', value);
    }
  }
}
